import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'LeadFormV2Component' })(
  ({ brandType, brandColors, type, typography }) => ({
    inputLabel: {
      ...type['14_medium'],
      letterSpacing: '-0.02rem',
      color: brandColors.heroBlue,
      marginBottom: typography.pxToRem(4),
    },
    homeOwnershipRadioContainer: {
      width: '100%',
      marginBottom: typography.pxToRem(20),
      display: 'flex',
      flexDirection: 'column',
    },
    homeOwnershipRadioOptionLabel: {
      ...brandType['body-s'],
      color: brandColors.tintsNeutral20,
      marginLeft: typography.pxToRem(10),
    },
    radioOption: {
      display: 'flex',
      alignItems: 'center',
    },
  })
);

export default useStyles;
